import React from 'react';
import '../../../css/dashboardHeader.css';

function DashboardHeader() {
  return (
    <div className="dashboard-header">
        <div className="dashboard-metrics">
            <div className="metrics">
                <div className="metric-card">
                    <h3>18.6K</h3>
                    <p>Utilisations</p>
                </div>
                <span className="metric-change positive">+18%</span>
            </div>
            <div className="metrics">
                <div className="metric-card">
                    <h3>55.9K</h3>
                    <p>Total Inscription</p>
                </div>
                <span className="metric-change positive">+25%</span>
            </div>
            <div className="metrics">
                <div className="metric-card">
                    <h3>54%</h3>
                    <p>Remboursées</p>
                </div>
                <span className="metric-change negative">-7%</span>
            </div>
          
          
        </div>
      </div>
  )
}

export default DashboardHeader